import { makeAutoObservable } from "mobx";

export class AISuggestionsStore {
  prompt = "";

  constructor() {
    makeAutoObservable(this);
  }

  setPrompt = (value) => {
    this.prompt = value;
  };
}

